import { render, staticRenderFns } from "./QuizAddition.vue?vue&type=template&id=3649a858&scoped=true&"
import script from "./QuizAddition.vue?vue&type=script&lang=js&"
export * from "./QuizAddition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3649a858",
  null
  
)

export default component.exports